import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37d916cc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/methodPayment/methodPayment.scss?vue&type=style&index=0&id=37d916cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d916cc",
  null
  
)

export default component.exports